import Config from '@/store/Config.js';
import store from '@/store/Store.js';
import jwt_decode from 'jwt-decode';

export default {

  user: {
    authenticated: false,
  },
  
  sharedState: store.state,
  config: Config.config,

  login(context, creds, redirect) {
    const me = this;
    context.$http.post(me.config.api + 'login', creds).then(response => {
      localStorage.setItem('id_token', response.data);
      this.user.authenticated = true;
      this.loading = false;
      console.log('Login sucessful');
      if(redirect) {
        console.log('In login redirect ' + redirect);
        context.$router.push({ name: 'Dashboard' });
        location.reload();
      }

    }).catch((err) => {
      context.error = 'Error logging in. Please ensure username and password are correct';
      console.error(err);
      this.loading = false;
    })
  },



  logout(context) {
    localStorage.removeItem('id_token');
    this.user.authenticated = false; // is the required?
    context.$router.push('/login');
  },

  forgotPassword(context, email, redirect) {
    const me = this;
    context.$http.post(me.config.api + 'email', email).then(response => {

		context.success = response.data.message;
      if(redirect) { 
		    context.$router.push(redirect);
      }

    }).catch((err) => {
    	console.log(err);
      context.error = err.data.message;
    })
  },
  checkAuth() {
    console.log('Check Auth called in Auth Check');
    var jwt = localStorage.getItem('id_token')
    if(jwt) {
      this.user.authenticated = true;
      var authenticated = true;
      return authenticated
    }
    else {
      this.user.authenticated = false;
      var authenticated = false;
      return authenticated
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/auth/AuthCheck.js